import { Grid } from "@mui/material";
import React from "react";
import { stylesSx } from "./styles";

const HomeAd = () => {
    return (
        <main>
            <section
                id="main"
                style={{
                    minHeight: "calc(100vh - 80px)",
                    backgroundColor: "#d9cdd2",
                }}
            >
                <Grid container>
                    <Grid
                        item
                        xs={12}
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <img
                            src="/img/home.png"
                            alt=""
                            style={{
                                width: "100%",
                                maxHeight: "80vh",
                                objectFit: "contain",
                            }}
                        />
                    </Grid>
                </Grid>
            </section>
        </main>
    );
};

export default HomeAd;
